<div class="Notitzen row">
  <div class="col">
    @for (item of Items; track item.key) {
    <div class="row note">
      <div class="col">
        <div class="row">
          <div class="col">
            <strong>
              {{item.text}}
            </strong>
          </div>
          <div class="col-auto">
            <i class="bi bi-trash3-fill" (click)="DeleteEntry(item.key)" style="
    font-size: normal;
color:red;
    display: inline-block;
    width: 32px;
    cursor: pointer;
    height: 32px;
    margin: 0 15px;
                "></i>
          </div>
        </div>
        <div class="row">
          <div class="col">
            {{item.erstelltAm}}
          </div>
          <div class="col-auto">
            {{item.erstelltDurch}}
          </div>
        </div>
      </div>
    </div>
    }
  </div>
</div>
<div class="NotitzenEdit row" (keyup.enter)="SendNewEntry()">
  <div class="col">
    <textarea  class="form-control" [(ngModel)]="NewText"></textarea>
  </div>
  <div class="col-auto">
    <div class="btn btn-primary" (click)="SendNewEntry()">Hinzufügen</div>
  </div>
</div>
